export default __webpack_public_path__ + "static/media/DEBoK_Logo-White.e3808c9d.png";